// ─────────────────────────────────────────────────────────────────────────────
// contactLinks.ts — single source of truth for whether contact actions
// (email / LinkedIn) are live links anywhere in the app.
//
// Every layout/pattern that renders a mailto or LinkedIn link calls
// getMailtoHref()/getLinkedinHref() instead of building the href inline.
// Flipping a flag below disables the action everywhere in one change —
// no per-component edits needed. When disabled, href comes back as
// `undefined`, so React renders the <a> with no href attribute at all:
// not clickable, not keyboard-focusable as a link, and the address/handle
// never appears in that attribute's rendered HTML.
// ─────────────────────────────────────────────────────────────────────────────

export const CONTACT_LINKS_ENABLED = {
  email:    false,
  linkedin: true,
};

export function getMailtoHref(email: string): string | undefined {
  return CONTACT_LINKS_ENABLED.email ? `mailto:${email}` : undefined;
}

export function getLinkedinHref(linkedin: string): string | undefined {
  return CONTACT_LINKS_ENABLED.linkedin ? `https://${linkedin}` : undefined;
}
